import React, { useRef } from 'react';
import useDuperbrowseLink from '../../../../../Duperbrowse/hooks/useDuperbrowseLink';
import { useBiDataForDeviationLink } from '../../../../../Duperbrowse/DeviationLink/useBiDataForDeviationLink';
import Button from '../../../../../Button';
import { getDeviationUrl } from '../../../../_helpers';
import { getDeviationEntityId } from '../../../../../redux/normalizr/schemas/deviation';
import s from './PollDuperbrowseLink.scss';
/*
  Using our own component-specific component here instead of modifying DeviationLink
  to accept an arbitrary component due to some small if statements in DeviationLink's
  definition not playing well with the data on polls. Modifying DeviationLink will
  take more effort to assure no regressions occur than just creating this small component.
*/ const PollDuperbrowseLink = ({ deviation, children })=>{
    const ref = useRef();
    const linkBiData = useBiDataForDeviationLink(deviation);
    const onDuperbrowseClick = useDuperbrowseLink(getDeviationEntityId(deviation), ref);
    return /*#__PURE__*/ React.createElement(Button, {
        href: getDeviationUrl(deviation),
        view: "b14",
        onClick: onDuperbrowseClick,
        className: s['button'],
        biData: linkBiData
    }, children);
};
PollDuperbrowseLink.displayName = 'PollDuperbrowseLink';
export default PollDuperbrowseLink;
